import { getAuth } from "firebase/auth";
import { getAuthCentral } from "../../config/FirebaseConfig";
import { getFirestore, doc, getDoc, collection } from "firebase/firestore";
import addLogDocument from "../addLogDocument.js"; // Assuming you have a similar function to log actions
import { checkDB, getDocDataById } from "../../models/DataFunctions.js";

async function createNewFolder(
  token,
  prefix,
  payment_allowed,
  use_facture_mat,
  folder_type,
  interventiondone,
  postal,
  adresse,
  pack,
  ville,
  nom,
  prenom,
  num,
  comments,
  invoice_id,
  reglement,
  clientmemberid,
  date,
  heure,
  minute,
  startdate,
  enddate,
  clientId,
  packid,
  structure,
  collectif_options_selected,
  master_id,
  author_id,
  marque,
  particulier = null,
  audit_config = null,
  addCarnet = false
) {
  // Define the endpoint URL
  const url = prefix + "folders";

  // Define the request body
  const body = {
    postal: postal,
    adresse: adresse,
    pack: pack,
    packid: packid,
    structure_type: structure,
    collectif_options_selected: collectif_options_selected,
    ville: ville,
    nom: nom,
    prenom: prenom,
    payment_allowed: payment_allowed,
    use_facture_mat: use_facture_mat,
    folder_type: folder_type,
    num: num,
    comments: comments,
    date: date,
    heure: heure,
    minute: minute,
    client: clientId,
    master_id: master_id,
    interventiondone: interventiondone || false,
    invoice_id: invoice_id,
    reglement: reglement,
    clientmemberid: clientmemberid || "vide",
    startdate: startdate || "../../....",
    enddate: enddate || "../../....",
    author_id: author_id,
    marque: marque,
    particulier: particulier,
    audit_config: audit_config,
    add_carnet: addCarnet
  };

  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  try {
    let start = new Date();
    // Make the POST request
    const response = await fetch(url, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(body),
    });

    // Get the current user
    const auth = getAuthCentral();
    const currentUser = auth.currentUser;

    if (!currentUser) {
      console.error("User not logged in");
      return null;
    }

    const db = getFirestore();
    const userRef = doc(db, "user", currentUser.uid);
    const userSnapshot = await getDoc(checkDB(userRef));

    if (!userSnapshot.exists()) {
      console.error("User document not found");
      return null;
    }

    const org_id = userSnapshot.get("org_id");
    const responseText = await response.text();
    let end = new Date();
    let elapsed = end - start;
    // Add log document (assuming addLogDocument is a utility function you have)
    await addLogDocument(
      url,
      prefix,
      userRef,
      org_id,
      response.status.toString(),
      "",
      "",
      JSON.stringify(body),
      responseText,
      "POST",
      elapsed
    );

    // Check if the request was successful
    if (response.ok) {
      const dict = JSON.parse(responseText);
      const documentId = dict["id"];

      // Return the Firestore document reference
      return doc(db, "folder", documentId);
    } else {
      console.error(`Error: ${response.status}`);
      return null;
    }
  } catch (error) {
    // Handle exceptions
    console.error("Error:", error);
    return null;
  }
}

export default createNewFolder;
